<script lang="ts">
	import type { HTMLImgAttributes } from 'svelte/elements';

	import { page } from '$app/state';
	import { thumbnailUrl } from '$lib';

	const {
		src,
		defaultSize,
		minSize,
		maxSize,
		...rest
	}: {
		src: string;
		defaultSize?: number;
		minSize?: number;
		maxSize?: number;
	} & HTMLImgAttributes = $props();

	const thumbnailSizes = $derived(
		__THUMBNAIL_SIZES__.filter(
			(size) => (!minSize || minSize <= size) && (!maxSize || size <= maxSize),
		),
	);
	const imageUrl = (size: number) => thumbnailUrl(page.data.store.media_base_url, src, size);
	const srcset = $derived(thumbnailSizes.map((size) => `${imageUrl(size)} ${size}w`).join(', '));
	const webpSrcset = $derived(
		thumbnailSizes
			.map((size) => `${imageUrl(size).replace(/\.jpe?g$/g, '.webp')} ${size}w`)
			.join(', '),
	);

	let imageWidth: number | undefined = $derived(defaultSize ?? thumbnailSizes[0]);
</script>

<picture>
	<source srcset={webpSrcset} sizes={rest.sizes ?? `${imageWidth}px`} type="image/webp" />
	<img
		bind:clientWidth={imageWidth}
		src={imageUrl(defaultSize ?? thumbnailSizes[0])}
		{srcset}
		{...rest}
		sizes={rest.sizes ?? `${imageWidth}px`}
		alt={rest.alt ?? src}
		class={['w-full mix-blend-darken', rest.class]}
	/>
</picture>
